export default "/static/vaccine/banner.jpg"